import { useParams } from "react-router-dom";
import { Cards, Crumbs, Cta } from "../components/Bits";
import { Head } from "../components/Head";
import { useData } from "../lib/data";
import { origin } from "../lib/util";
import NotFound from "./NotFound";

export const ingTitle = p => `Opskrifter med ${p.name} – ${p.count} billige retter`;
export const ingDesc = p => `${p.count} billige opskrifter med ${p.name}, sorteret efter pris pr. person. Med tid, ingredienser og fremgangsmåde til hverdagen.`;

export function IngredientPage() {
  const { slug } = useParams();
  const { IBY, BY } = useData();
  const p = IBY[slug];
  if (!p) return <NotFound />;
  const rs = p.recipe_slugs.map(s => BY[s]).filter(Boolean);
  const avg = rs.length ? Math.round(rs.reduce((a, r) => a + r.price, 0) / rs.length) : 0;
  const ld = [
    { "@context": "https://schema.org", "@type": "ItemList", name: `Opskrifter med ${p.name}`, itemListElement: rs.map((r, i) => (
      { "@type": "ListItem", position: i + 1, name: r.title, url: `${origin()}/opskrifter/${r.slug}/` })) },
    { "@context": "https://schema.org", "@type": "BreadcrumbList", itemListElement: [
      { "@type": "ListItem", position: 1, name: "Ingredienser", item: `${origin()}/opskrifter-med/` },
      { "@type": "ListItem", position: 2, name: `Opskrifter med ${p.name}` }] },
  ];
  return (
    <>
      <Head title={ingTitle(p)} path={`opskrifter-med/${p.slug}/`} ld={ld} desc={ingDesc(p)} />
      <Crumbs trail={[["opskrifter-med/", "Ingredienser"], [null, p.name]]} />
      <div className="wrap">
        <div className="ptop"><h1 data-testid="ingredient-title">Opskrifter med {p.name}</h1>
          <div data-testid="ingredient-intro">{p.intro.split(/\n\s*\n/).map((t, i) => <p key={i} className="lead">{t}</p>)}</div></div>
        <p className="count" data-testid="ingredient-count">{rs.length} opskrifter, billigste først. Gennemsnitlig pris: ca. {avg} kr. pr. person.</p>
        <Cards rs={rs} />
        <div className="note">Find flere råvarer under <a href="/opskrifter-med/" data-testid="ingredient-all-link">alle ingredienser</a>.</div>
        <div className="blk"><Cta h="Gør det til en madplan" p="Vælg dine favoritter, og få en samlet indkøbsliste." /></div>
      </div>
    </>
  );
}

export function IngredientsIndex() {
  const { ingredients } = useData();
  const ld = [{ "@context": "https://schema.org", "@type": "ItemList", name: "Ingredienser", itemListElement: ingredients.map((p, i) => (
    { "@type": "ListItem", position: i + 1, name: `Opskrifter med ${p.name}`, url: `${origin()}/opskrifter-med/${p.slug}/` })) }];
  const ex = ingredients.slice(0, 6).map(p => p.name);
  return (
    <>
      <Head title="Ingredienser: find opskrifter efter råvare" path="opskrifter-med/" ld={ld}
        desc={`Find billige opskrifter efter ingrediens, fx ${ex.slice(0, -1).join(", ")} og ${ex[ex.length - 1]}. Alle med pris pr. person.`} />
      <Crumbs trail={[[null, "Ingredienser"]]} />
      <div className="wrap">
        <div className="ptop"><h1 data-testid="ingredients-title">Ingredienser</h1>
          <p className="lead">Har du en bestemt råvare i køleskabet eller på tilbud? Vælg ingrediensen, og se alle opskrifter med den, billigste først.</p></div>
        <p className="count" data-testid="ingredients-count">{ingredients.length} ingredienser</p>
        <div className="ilist" data-testid="ingredients-list">{ingredients.map(p => (
          <a key={p.slug} className="cat" href={`/opskrifter-med/${p.slug}/`} data-testid={`ingredient-chip-${p.slug}`}>
            <span aria-hidden="true">{p.emoji}</span><div>{p.name}<small>{`${p.count} opskrifter`}</small></div></a>
        ))}</div>
      </div>
    </>
  );
}
